import React, { Fragment, useEffect, useState, useRef } from 'react';
import { ArrowLeft, ArrowRight, Bookmark, Delete, Filter, Plus, Trash, Trash2, XCircle } from 'react-feather';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Row, Col, ListGroup, ListGroupItem, Button, Input, InputGroup, FormGroup, Label, Badge } from 'reactstrap';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Calendar } from 'react-modern-calendar-datepicker';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select'
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { colors } from '../../helpers/meta';
import { colourStyles, enums } from '../../helpers/common';
import { createFilterRequest, deleteFilterRequest, listFilterRequest } from '../../helpers/requests';
import { setError } from '../../redux/actions/highlights';
import { deleteFilter } from '../../redux/actions/savedFilters';
import '../../App.css'
import { useLocalStorage } from '../Hooks/useLocalStorage';



const MainFilter = (props) => {

    const loaded = useSelector(state => state.savedFilters.loaded);
    const branchFilters = useSelector(state => state.savedFilters.branchFilters);
    const dateFilters = useSelector(state => state.savedFilters.dateFilters);
    const dispatch = useDispatch();
    const [showFilters, setShowFilters] = useState(false);
    const [customSelection, setCustomSelection] = useState(false)
    const [deleteFilters, setDeleteFilters] = useState(false)
    const user = useSelector(state => state.auth.user);
    // const [floorId, setFloor] = useState()
    const [floorId, setFloor] = useLocalStorage('floor', null)

    const [floorId2, setFloor2] = useState()
    const [isFloorActive, setIsFloorActive] = useState(false);
    const { id, title } = useParams();

    const toggle = () => {
        setShowFilters(!showFilters);
    }

    const [selectedDay, setSelectedDay] = useState(null);
    const [dateFilter, setDateFilter] = useState(false);
    const [branchFilter, setBranchFilter] = useState(false);
    const dateRef = useRef(null);
    const branchRef = useRef(null);
    const [dateLabel, setDateLabel] = useState("");
    const [branchLabel, setBranchLabel] = useState("");
    const [dateLoader, setDateLoader] = useState(false);
    const [branchLoader, setBranchLoader] = useState(false);
    // const [selection, setSelection] = useState("all");
    const [selection, setSelection] = useLocalStorage("selection", null);

    const [dateSelection, setDateSelection] = useState("today");
    const [dateSelectionTwo, setDateSelectionTwo] = useState("today");
    const [singleCity, setSingleCity] = useState("lahore")
    // const [storeName, setStoreName] = useState();
    const [storeName, setStoreName] = useLocalStorage("storeName", null);

    const defaultDate = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }



    /***** Extra  Variables used for Comparison filter *****/

    const [singleCity2, setSingleCity2] = useState("lahore")
    const [store2, setStore2] = useState()
    const [selection2, setSelection2] = useState("all");
    const [storeName2, setStoreName2] = useState();

    const [selectedDayRangeTwo, setSelectedDayRangeTwo] = useState({
        from: defaultDate,
        to: defaultDate
    });
    /******    ********/


    /***** Extra  Variables used for Insights filter *****/

    const [yearRnage, setYearRange] = useState(0)
    const [selectType, setSelectType] = useState('insightsdaily')
    const [insightsYearlyDate, setInsightsYearlyDate] = useState()

    /******    ********/


    const savedDate = JSON.parse(localStorage.getItem("dateRange"));


    // const [selectedDayRange, setSelectedDayRange] = useState(
    //     {
    //         from :  defaultDate,
    //         to :  defaultDate
    //     }
    // );
    const [selectedDayRange, setSelectedDayRange] = useLocalStorage('selectedDayRange',
        {
            from: defaultDate,
            to: defaultDate
        }
    );



    const setSelectedDayRangeFromCalendar = (obj) => {

        setSelectedDayRange(obj);
        setDateSelection("");
    }

    const setDateForEmployeeActivity = (obj) => {
        console.log("dateObj", obj);
        let object = {
            from: obj.from,
            to: obj.from
        }
        setSelectedDayRange(object);
        setDateSelection("");

    }


    const setDateAndRangeForInsights = (obj) => {
        let start;
        let end;
        if (selectType === "insightsweekly") {
            start = moment(new Date(obj.from.year, obj.from.month - 1, obj.from.day)).startOf('week').toDate();
            end = moment(new Date(obj.from.year, obj.from.month - 1, obj.from.day)).endOf('week').toDate();
            var object = {
                from: { day: start.getDate(), month: start.getMonth() + 1, year: start.getFullYear() },
                to: { day: end.getDate(), month: end.getMonth() + 1, year: end.getFullYear() },
            }
            setSelectedDayRange(object);
            setDateSelection("");
        }
        else if (selectType === "insightsdaily") {
            var object = {
                from: obj.from,
                to: obj.from,
            }
            setSelectedDayRange(object);
            setDateSelection("");
        }
    }


    let cities = {};
    const options = user.access.map((val) => {
        let _city = val.city.toLowerCase();
        cities[_city] = val.city;
        return { ...val, value: val._id }
    });
    const [option, setOption] = useLocalStorage("option", options);


    const setOptionByDefault = (e) => {
        setOption(e);
        setSelection("custom")
    }
    const selectAll = () => {
        setSelection("all");
        setOption(options);
    }

    const selectByCity = (city) => {
        setSelection(city);
        var locations = options.filter(store => store.city.toLowerCase() === city.toLowerCase());
        setOption(locations);
    }


    const setSelectedDayRangeFromCalendarTwo = (obj) => {
        setSelectedDayRangeTwo(obj);
        setDateSelection("");
    }


    const selectBysingleCity = (city) => {
        // if (singleCity === city) {
        //     setSingleCity()
        // }
        // else
        {
            setSingleCity(city)
        }
    }

    const selectBysingleCity2 = (city) => {
        setSingleCity2(city)
    }
    const selectByStore = (store) => {
        // if(selection === store._id){
        //     setSelection();
        //     setStoreName()
        // }
        // else
        {
            setIsFloorActive(false)
            setFloor()
            setSelection(store._id);
            setStoreName(store.label)
            var locations = options.filter(stores => stores._id === store._id);
            setOption(locations)
            if (store.floors.length === 1 || props.pageTitle === "Conversion") {
                setFloor({ _id: store.floors[0]._id, name: store.floors[0].floor_label })
            }

        }

    }


    const selectByStore2 = (store) => {
        setSelection2(store._id);
        setStoreName2(store.label)
        var locations = options.filter(stores => stores._id === store._id);
        setStore2(locations)
    }



    const selectByfloor = (floor) => {
        setFloor({ _id: floor._id, name: floor.floor_label })
        setIsFloorActive(true)
    }

    const selectByfloor2 = (floor) => {
        setFloor2({ _id: floor._id, name: floor.floor_label })
    }

    const selectByBranchFilter = (e) => {
        setSelection(e._id);
        var locations = options.filter(store => e.filter.map(row => row.value).indexOf(store._id) >= 0);
        setOption(locations);
    }

    const selectByDateFilter = (e) => {
        setDateSelection(e.id);
        setSelectedDayRange({ from: e.filter.from, to: e.filter.to });
    }


    const selectByMultipleDateFilter = (e) => {
        setDateSelection(e.id);
        setSelectedDayRange({ from: e.filter.first_from, to: e.filter.first_to })
        setSelectedDayRangeTwo({ from: e.filter.second_from, to: e.filter.second_to })
    }

    const selectByInsightsDateFilter = (e) => {

        setDateSelection(e.id);
        if (selectType === "insightsyearly") {
            let year = new Date(e.filter.to).getFullYear();
            let CurrentYear = new Date().getFullYear();
            let _yearRange = (CurrentYear - year) / 12;
            setYearRange(_yearRange.toFixed() * 12)
            let obj = {
                value: year,
                label: year
            }
            setInsightsYearlyDate(obj)
        } else {
            setSelectedDayRange({ from: e.filter.from, to: e.filter.to })
        }

    }


    const updateFilter = (options) => {
        console.log('running');

        let _option = []
        let sids = [];
        let fids = [];
        // var _option =
        if(options.length) {
            options?.map((row) => {
                sids.push(row.value);
                fids.push(row.floors[0]?._id)
    
            })

        }
        else {
            option?.map((row) => {
                sids.push(row.value);
                fids.push(row.floors[0]._id)
    
            })
        }
       
        console.log('sids fids', sids, fids);
        let selected;
        // if (props.pageTitle != "Summary") {
        if (props.type != "default") {

            selected = { floorName: floorId?.name, storeName: storeName, from: getDateString(selectedDayRange?.from, "ll"), to: getDateString(selectedDayRange?.to, "ll") }

        }
        var start, end;
        const saved = JSON.parse(localStorage.getItem("dateRange"));




        start = moment(new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day)).startOf("day");
        end = moment(new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day)).endOf("day");
        // let fids = _option

        var filter = { start: start, end: end, sid: sids, type: "d", fid: fids, selected: selected };

        props.updateFilter(filter)

    }

    const updateFilterForGold = () => {
        var _option = [];
        option?.map((row) => {
            _option.push(row.value);
        })
        var _floorId;

        if (floorId === null) {
            console.log('');
            _floorId = { _id: option[0]?.floors[0]?._id, name: option[0]?.floors[0]?.floor_label }
        }
        else {
            _floorId = floorId;
        }
        let selected;

        console.log('selection ', _floorId,floorId );
        if (props.type != "default") {
            selected = { floorName: floorId?.name, storeName: storeName, from: getDateString(selectedDayRange?.from, "ll"), to: getDateString(selectedDayRange?.to, "ll") }

        }

        var start, end;


        {
            start = moment(new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day)).startOf("day");
            end = moment(new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day)).endOf("day");

        }

        var filter = { start: start, end: end, sid: _option[0], type: "d", fid: props.pageTitle === "Traffic" ? [_floorId?._id] : _floorId?._id };
        if (props.pageTitle === "Categories") {
            delete filter["type"];
        }
        props.updateFilter(filter)

    }


    const updateFilterForComparison = () => {
        var _store1 = option?.map((row) => {
            return row.value;
        })
        var _store2 = store2?.map((row) => {
            return row.value;
        })

        var store_id;
        var type;
        var selected;
        if (props.compareType === 'single') {
            store_id = [_store1[0], _store1[0]];
            type = 'single'
            selected = { storeName: storeName, firstFrom: getDateString(selectedDayRange?.from, "ll"), firstTo: getDateString(selectedDayRange?.to, "ll"), secondFrom: getDateString(selectedDayRangeTwo?.from, "ll"), secondTo: getDateString(selectedDayRangeTwo?.to, "ll") }

        } else {
            store_id = [_store1[0], _store2?.length ? _store2[0] : _store1[1]];
            type = 'multiple'
            selected = { storeName: typeof storeName === "string" ? storeName : option[0].label, secondStore: typeof storeName === "string" ? storeName2 : option[1].label, from: getDateString(selectedDayRange?.from, "ll"), to: getDateString(selectedDayRange?.to, "ll") }

        }

        var startTime = ["00:00", "00:00"]
        var endTime = ["23:59", "23:59"]
        var startDate1 = moment(new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day)).startOf("day");
        var endDate1 = moment(new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day)).endOf("day");
        var startDate2 = moment(new Date(selectedDayRangeTwo.from.year, selectedDayRangeTwo.from.month - 1, selectedDayRangeTwo.from.day)).startOf("day");
        var endDate2 = moment(new Date(selectedDayRangeTwo.to.year, selectedDayRangeTwo.to.month - 1, selectedDayRangeTwo.to.day)).endOf("day");
        var filter = { sd: [startDate1, startDate2], ed: [endDate1, endDate2], st: startTime, et: endTime, sid: store_id, t: "d", type: type, selected: selected };
        props.updateFilter(filter)
    }


    const updateFilterForInsightsAndConversion = () => {
        var _option = option?.map((row) => {
            return row.value;
        })
        let _startDate;
        let _endDate;
        let type;
        var selected
        if (selectType === 'insightsyearly') {
            if (insightsYearlyDate?.value) {
                _startDate = moment(insightsYearlyDate?.value, "YYYY").startOf("year").startOf("day")
                _endDate = moment(insightsYearlyDate?.value, "YYYY").endOf("year").endOf("day");
                type = "yearly"
                selected = { storeName: storeName, from: getDateString(_startDate, "ll"), to: getDateString(_endDate, "ll") }

            }
        }
        else {
            _endDate = moment(new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day)).endOf("day");
            _startDate = moment(new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day)).startOf("day");
            selected = { storeName: storeName, from: getDateString(selectedDayRange?.from, "ll"), to: getDateString(selectedDayRange?.to, "ll") }

        }

        var filter;
        if (props.pageTitle === 'Conversion') {
            // let currentStore = options?.filter((item) => {
            //     return item._id === id
            // })
            // let all_floors = currentStore[0].floors.map((item) => {
            //     return item._id
            // })
            filter = {
                sid: _option[0],
                end: _endDate,
                start: _startDate,
                fid: [floorId._id],
                storeName: storeName
            }
        }
        else {
            filter = { sid: _option[0], end: _endDate, start: _startDate, type: type ? type : selectType === "insightsweekly" ? "weekly" : "daily" };
        }


        props.updateFilter(filter);
    }


    const [years, setYears] = useState()
    const yearlyInsights = (yea) => {
        const year = new Array(12).fill(0).map((val, index) => {
            return { value: new Date().getFullYear() - index - (yearRnage), label: new Date().getFullYear() - index - (yearRnage) }
        });
        setYears(year)
    }

    const createDateFilters = () => {
        var dateFilters = {};
        let today = moment(new Date());
        let yesterday = moment(new Date()).subtract(1, "days");
        let thisWeek = moment(new Date()).startOf("week");
        let lastWeek = moment(new Date()).subtract(1, "week").startOf("week");
        let thisMonth = moment(new Date()).startOf("month");
        let lastMonth = moment(new Date()).subtract(1, "month").startOf("month");
        let thisYear = moment(new Date()).startOf("year");
        let lastYear = moment(new Date()).subtract(1, "year").startOf("year");
        dateFilters["today"] = { type: "day", label: "Today", from: getDateObject(today), to: getDateObject(today) };
        dateFilters["yesterday"] = { type: "day", label: "Yesterday", from: getDateObject(yesterday), to: getDateObject(yesterday) };
        dateFilters["thisWeek"] = { type: "week", label: "Current Week", from: getDateObject(thisWeek), to: getDateObject(today) };
        dateFilters["lastWeek"] = { type: "week", label: "Previous Week", from: getDateObject(lastWeek), to: getDateObject(lastWeek.endOf("week")) };
        dateFilters["thisMonth"] = { type: "month", label: thisMonth.format("MMMM"), from: getDateObject(thisMonth), to: getDateObject(today) };
        dateFilters["lastMonth"] = { type: "month", label: lastMonth.format("MMMM"), from: getDateObject(lastMonth), to: getDateObject(lastMonth.endOf("month")) };
        dateFilters["thisYear"] = { type: "year", label: thisYear.format("YYYY"), from: getDateObject(thisYear), to: getDateObject(today) };
        dateFilters["lastYear"] = { type: "year", label: lastYear.format("YYYY"), from: getDateObject(lastYear), to: getDateObject(lastYear.endOf("year")) };
        return dateFilters;
    }

    const getDateObject = (momentObj) => {
        return {
            year: momentObj.year(),
            month: momentObj.month() + 1,
            day: momentObj.date()
        }
    }

    const getDateString = (dateObject, format = "YYYY-MM-DD HH:MM") => {
        return moment(new Date(dateObject?.year, dateObject?.month - 1, dateObject?.day)).startOf("day").format(format);
    }

    const getDifference = (from, to) => {
        if (from && to) {
            var start = moment(new Date(from.year, from.month - 1, from.day)).startOf("day");
            var end = moment(new Date(to.year, to.month - 1, to.day)).endOf("day");
            return Math.abs(end.diff(start, "days"));
        } else {
            return 0;
        }
    }

    const selectDateFilter = (key) => {
        setDateSelection(key);
        let date = dates[key];
        setSelectedDayRange({ from: date.from, to: date.to });
    }


    const createMultipleDateFilter = async () => {
        if (!dateLabel || dateLabel.trim() == 0) {
            dispatch(setError("Label for date filter cannot be empty"));
            return;
        }
        setDateLoader(true);
        let requestData = {
            params: {
                filter: {
                    first_from: selectedDayRange.from,
                    first_to: selectedDayRange.to,
                    second_from: selectedDayRangeTwo.from,
                    second_to: selectedDayRangeTwo.to,
                    range: "multiple"
                },
                label: dateLabel,
                type: "date",
            },
            dispatch
        };
        await createFilterRequest(requestData);
        setDateLabel("");
        setDateFilter(false);
        setDateLoader(false);
    }

    const createDateFilter = async () => {
        if (!dateLabel || dateLabel.trim() == 0) {
            dispatch(setError("Label for date filter cannot be empty"));
            return;
        }
        setDateLoader(true);
        let requestData = {
            params: {
                filter: {
                    from: selectedDayRange.from,
                    to: selectedDayRange.to,
                    range: "single"
                },
                label: dateLabel,
                type: "date"
            },
            dispatch
        };
        await createFilterRequest(requestData);
        setDateLabel("");
        setDateFilter(false);
        setDateLoader(false);
    }

    const createInsightsDateFilter = async () => {

        if (!dateLabel || dateLabel.trim() == 0) {
            dispatch(setError("Label for date filter cannot be empty"));
            return;
        }

        let fromDate;
        let toDate;

        if (selectType === "insightsyearly") {
            fromDate = moment(insightsYearlyDate?.value, "YYYY").startOf("year").startOf("day")
            toDate = moment(insightsYearlyDate?.value, "YYYY").endOf("year").endOf("day");
        }
        else {
            fromDate = selectedDayRange.from;
            toDate = selectedDayRange.to
        }

        setDateLoader(true);
        let requestData = {
            params: {
                filter: {
                    from: fromDate,
                    to: toDate,
                    range: selectType
                },
                label: dateLabel,
                type: "date"
            },
            dispatch
        };
        await createFilterRequest(requestData);
        setDateLabel("");
        setDateFilter(false);
        setDateLoader(false);

    }

    const createBranchFilter = async () => {
        if (!branchLabel || branchLabel.trim() == 0) {
            dispatch(setError("Label for branch filter cannot be empty"));
            return;
        }
        setBranchLoader(true);
        let requestData = {
            params: {
                filter: option.map(row => { return { value: row.value, label: row.label, country: row.country, state: row.state, city: row.city } }),
                label: branchLabel,
                type: "branch"
            },
            dispatch
        };
        await createFilterRequest(requestData);
        setBranchLabel("");
        setBranchFilter(false);
        setBranchLoader(false);
    }

    const localDeleteFilter = async (id) => {
        let requestData = {
            params: {
                id: id
            },
            dispatch
        };
        await deleteFilterRequest(requestData);
        dispatch(deleteFilter(id));
    }







    useEffect(() => {
        if (!loaded) {
            let requestData = {
                dispatch: dispatch
            };
            listFilterRequest(requestData)
        }
    }, [loaded])


    useEffect(() => {
        if (props.type === 'default') {
            setSelection("all");
            setOption(options)
            setFloor({ _id: options[0]?.floors[0]?._id, name: options[0]?.floors[0]?.floor_label });
            updateFilter(options);
        }
        if (props.type === 'compareMultiple') {
            setOption(options)

            updateFilterForComparison()
            setSelection(option[0]._id);
            setStoreName(option[0].label);
            setSelection2(option[1]._id);
            setStoreName2(option[1].label)
            setStore2([option[1]])
        }
        if (props.type === "premium" || props.pageTitle === "conversion" || props.type === "silver") {
            updateFilterForInsightsAndConversion();
            setOption(options)

            setSelection(option[0]._id);
            setStoreName(option[0].label);



        }
        // if (props.type === 'gold' || props.pageTitle === 'Heatmaps' || props.pageTitle === 'Categories') {
        if (props.type === 'gold') {
            console.log('selection', selection);
            if (selection === null || selection.length < 23) {
                setFloor({ _id: option[0]?.floors[0]?._id, name: option[0]?.floors[0]?.floor_label });
                setSelection(option[0]?._id);
                setStoreName(option[0]?.label);

            }
            // setFloor({ _id: option[0]?.floors[0]?._id, name: option[0]?.floors[0]?.floor_label });
            // setSelection(option[0]?._id);
            // setStoreName(option[0]?.label);
            setTimeout(() => {
                updateFilterForGold()
            }, 400);
            
        }
    }, [])







    useEffect(() => {
        let obj = {
            from: defaultDate,
            to: defaultDate
        }
        // setSelectedDayRange(obj)
    }, [selectType])


    useEffect(() => {
        yearlyInsights(yearRnage)
    }, [yearRnage])

    useEffect(() => {
        let _currentDate = new Date();
        if (dateSelection === 'today') {
            if (_currentDate.getDate() != selectedDayRange.from.day || _currentDate.getMonth() + 1 != selectedDayRange.from.month || _currentDate.getFullYear() != selectedDayRange.from.year) {
                setDateSelection('')
            }
        }


    }, [selectedDayRange])


    /* ****************

    useefect whose dependency is id is running only for conversion page 
    
    */

    useEffect(() => {
        if (props.pageTitle === "Conversion") {
            let currentStore = options?.filter((item) => {
                return item._id === id
            })
            setStoreName(currentStore[0]?.label);
            setSelection(currentStore[0]?._id);
            setSingleCity(currentStore[0]?.city.toLowerCase())
            if (currentStore[0]?.floors.length) {
                setFloor({ _id: currentStore[0]?.floors[0]?._id, name: currentStore[0]?.floors[0]?.floor_label })
            }
            setOption(currentStore);


            let _endDate = moment(new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day)).endOf("day");
            let _startDate = moment(new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day)).startOf("day");


            let all_floors = currentStore[0].floors.map((item) => {
                return item._id
            })

            if (props.pageTitle === 'Conversion') {
                var filter = {
                    sid: currentStore[0]?._id,
                    end: _endDate,
                    start: _startDate,
                    fid: [currentStore[0].floors[0]._id],
                    storeName: currentStore[0]?.label
                }
                props.updateFilter(filter)
            }
        }
    }, [id])



    const citiesMenu = Object.keys(cities).map((key) => {
        return (
            <ListGroupItem key={'city-' + key} className={selection == key ? 'active' : ''} tag="a" href="#" onClick={(e) => { e.detail == 2 ? setCustomSelection(true) : selectByCity(key); }}>
                {cities[key]}
            </ListGroupItem>
        )
    })


    const branchesMenuCustom = branchFilters.map((val) => {
        return (
            <ListGroupItem key={'dates-' + val._id} className={selection == val._id ? 'active' : ''} tag="a" href="#" onClick={(e) => { e.detail == 2 ? setCustomSelection(true) : selectByBranchFilter(val) }}>
                {val.label}
            </ListGroupItem>
        )
    })

    const storesWithFloors = Object.keys(cities).map((key) => {
        return (

            <ListGroupItem key={'city-' + key}
                className='white'
            >
                <div onClick={(e) => { selectBysingleCity(key); }} className={'cityItem p-2'}
                    //  className={singleCity === key ? 'active' : 'white'}
                    style={{ cursor: 'pointer', borderTop: "none", borderLeft: "none", borderRight: 'none' }}  >
                    <span key={'city-' + key} tag="a" href="#" >
                        {cities[key]}
                    </span>
                </div>

                {options.map((stores, index) => {
                    return (


                        stores.city === cities[key] &&
                        <>
                            <div className={singleCity === key ? "px-3 " : 'storeHide '} style={{ cursor: "pointer", }} >
                                <div className={storeName === stores.label ? isFloorActive === false ? '  storeItemActive p-2' : 'storeItem p-2 ' : "storeItem p-2"} onClick={(e) => { selectByStore(stores) }} >
                                    <span key={stores._id} tag='a' href="#" >
                                        {stores.label}
                                    </span>
                                </div>
                            </div>
                            {singleCity === key && (props.pageTitle != "Comparisons" && props.pageTitle != "Insights" && props.pageTitle != 'Conversion' && props.pageTitle != "Employee_Activity") && options[index].floors.length > 1 && options[index].floors.map((floor, index1) => {
                                {/* {singleCity === key && ( props.type === "gold" || props.type === "default" || props.type === "compareMultiple" ) && options[index].floors.length > 1 && options[index].floors.map((floor, index1) => { */ }

                                return (
                                    // <ListGroup className={selection === stores._id ? 'active' : 'hide'} key={index1}>
                                    //     <ListGroupItem key={index1} className={floorId?._id === floor._id ? 'active' : ''} onClick={(e) => { selectByfloor(floor) }}>
                                    <div className={selection === stores._id ? 'px-5 my-2 ' : ' hide'} style={{ cursor: "pointer", }} >
                                        <div className={floorId?.name === floor.floor_label ? 'storeItemActive p-2' : "p-2 storeItem"} onClick={(e) => { selectByfloor(floor) }} >
                                            {floor.floor_label}
                                        </div>

                                    </div>


                                    //     </ListGroupItem>
                                    // </ListGroup>

                                )
                            })

                            }
                        </>

                        // </ListGroupItem>
                        //         }
                        //  </ListGroup>

                    )
                })}
            </ListGroupItem>
        )
    })


    const storesForMUltiple = Object.keys(cities).map((key) => {
        return (

            <ListGroupItem key={'city-' + key}
                className='white'
            >
                <div onClick={(e) => { selectBysingleCity2(key); }} className={'cityItem p-2'}
                    //  className={singleCity === key ? 'active' : 'white'}
                    style={{ cursor: 'pointer', borderTop: "none", borderLeft: "none", borderRight: 'none' }}  >
                    <span key={'city-' + key} tag="a" href="#" >
                        {cities[key]}
                    </span>
                </div>

                {options.map((stores, index) => {
                    return (


                        stores.city === cities[key] &&
                        <>
                            <div className={singleCity2 === key ? "px-3 " : 'storeHide '} style={{ cursor: "pointer", }} >
                                <div className={storeName2 === stores.label ? isFloorActive === false ? '  storeItemActive p-2' : 'storeItem p-2 ' : "storeItem p-2"} onClick={(e) => { selectByStore2(stores) }} >
                                    <span key={stores._id} tag='a' href="#" >
                                        {stores.label}
                                    </span>
                                </div>
                            </div>
                            {/* {singleCity2 === key && (props.pageTitle != "Comparisons" && props.pageTitle != "Insights" && props.pageTitle != 'Conversion' && props.pageTitle != "Employee_Activity") && options[index].floors.length > 1 && options[index].floors.map((floor, index1) => { */}
                            {singleCity2 === key && (props.type === "default" || props.type === "gold" || props.type === "compareMultiple") && options[index].floors.length > 1 && options[index].floors.map((floor, index1) => {

                                return (
                                    // <ListGroup className={selection === stores._id ? 'active' : 'hide'} key={index1}>
                                    //     <ListGroupItem key={index1} className={floorId?._id === floor._id ? 'active' : ''} onClick={(e) => { selectByfloor(floor) }}>
                                    <div className={selection2 === stores._id ? 'px-5 my-2 ' : ' hide'} style={{ cursor: "pointer", }} >
                                        <div className={floorId2?.name === floor.floor_label ? 'storeItemActive p-2' : "p-2 storeItem"} onClick={(e) => { selectByfloor2(floor) }} >
                                            {floor.floor_label}
                                        </div>

                                    </div>


                                    //     </ListGroupItem>
                                    // </ListGroup>

                                )
                            })

                            }
                        </>

                        // </ListGroupItem>
                        //         }
                        //  </ListGroup>

                    )
                })}
            </ListGroupItem>
        )
    })


    // const storesForMUltiple = Object.keys(cities).map((key) => {
    //     return (

    //         <ListGroupItem key={'city-' + key} style={{ cursor: 'pointer' }}>

    //             <span key={'city-' + key} className={selection2 == key ? 'active' : ''} tag="a" href="#" onClick={(e) => { selectBysingleCity2(key); }}>
    //                 {cities[key]}
    //             </span>

    //             {
    //                 options.map((stores, index) => {
    //                     return (

    //                         <ListGroup className={singleCity2 === key ? 'active' : 'storeHide'} key={index}>
    //                             {
    //                                 stores.city === cities[key] &&
    //                                 <ListGroupItem className={storeName2 === stores.label ? 'active' : ''}>

    //                                     <span key={stores._id} tag='a' href="#" onClick={(e) => { selectByStore2(stores) }}>
    //                                         {stores.label}
    //                                     </span>

    //                                     {
    //                                         props.pageTitle != "Comparisons" && options[index].floors.map((floor, index1) => {
    //                                             return (

    //                                                 <ListGroup className={selection2 === stores._id ? 'active' : 'hide'} key={index1}>
    //                                                     <ListGroupItem key={index1} className={floorId2?._id === floor._id ? 'active' : ''} onClick={(e) => { selectByfloor2(floor) }}>
    //                                                         {floor.floor_label}
    //                                                     </ListGroupItem>
    //                                                 </ListGroup>

    //                                             )
    //                                         })
    //                                     }

    //                                 </ListGroupItem>
    //                             }
    //                         </ListGroup>
    //                     )
    //                 })
    //             }
    //         </ListGroupItem>
    //     )
    // })

    console.log("storesForMUltiple", storesForMUltiple);


    const dates = createDateFilters();

    const datesMenu = Object.keys(dates).map((key) => {
        return (
            <ListGroupItem key={'dates-' + key} className={dateSelection == key ? 'active' : ''} tag="a" href="#" onClick={() => selectDateFilter(key)}>
                {dates[key].label}
            </ListGroupItem>
        )
    })

    const singleRangeDateFilters = dateFilters.filter((val) => {
        return (val.filter.range === "single")
    })

    /*****************
   multipleDateFilters coming from dateFilters by filter out whose range is equal to multiple in filter object ( range==="multiple")
   */
    const multipleRangeDateFilters = dateFilters.filter((val) => {

        return (val.filter.range === "multiple")
    })




    const datesMenuCustom = singleRangeDateFilters.map((val) => {
        {
            return (
                <ListGroupItem key={'dates-' + val._id} className={dateSelection == val._id ? 'active' : ''} tag="a" href="#" onClick={() => selectByDateFilter(val)}>
                    {val.label}
                </ListGroupItem>
            )
        }
    })

    const multipleDatesMenuCustom = multipleRangeDateFilters.map((val) => {

        if (val.filter.range === "multiple") {
            return (
                <ListGroupItem key={'dates-' + val._id} className={dateSelection == val._id ? 'active' : ''} tag="a" href="#" onClick={() => selectByMultipleDateFilter(val)}    >
                    {val.label}
                </ListGroupItem>
            )
        }
    })

    /*********** **************************************/
    //   Date filter for Insights Page which are filter by its type here selectType === (dailyInsights weeklyInsights and yearlyInsights) 

    /* ****************************/



    const inisghtsDateFilter = dateFilters.filter((val) => {
        return (val.filter.range === selectType)

    })





    /******************************************************
     * 
     * Date menu custom for insights filter by selectType 
     * 
     *****************************************************/

    const inisghtsDateMenuCustom = inisghtsDateFilter.map((val) => {

        {
            return (
                <ListGroupItem key={'dates-' + val._id} className={dateSelection == val._id ? 'active' : ''} tag="a" href="#" onClick={() => selectByInsightsDateFilter(val)}    >
                    {val.label}
                </ListGroupItem>
            )
        }
    })



    var dateTyes = [
        { value: 'insightsdaily', label: "Daily", _id: 1 },
        { value: 'insightsweekly', label: "Weekly", _id: 2 },
        { value: 'insightsyearly', label: "Yearly", _id: 3 },

    ]
    const dateTypeForInsights = dateTyes.map(val => {
        return (
            <ListGroupItem key={'dates-' + val._id} className={selectType == val.value ? 'active' : ''} tag="a" href="#" onClick={() => setSelectType(val.value)}    >
                {val.label}
            </ListGroupItem>
        )
    })



    return (
        <Row className='mb-4 mt-1'>
            <Col sm={3} style={{ backgroundColor: '' }} className='p-2' >
                <h4 className='m-0 p-0 fw-normal'>{props.pageTitle}</h4>
            </Col>
            <Col className='text-end'>
                <Row>
                    <Col className='p-2 mt-2 ' md={10}>
                        { }
                        {
                            // (props.pageTitle === "Summary" || props.pageTitle === "Conversion") && <>
                            (props.type === "default" || props.pageTitle === "Conversion") && <>

                                {
                                    getDifference(selectedDayRange.from, selectedDayRange.to) == 0 ?
                                        <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>You have selected <strong>{props.updateStoreNameURL ? props.updateStoreNameURL : option.length}</strong> {option.length > 1 ? `${title ? '' : 'branches'} to view data from` : `${props.updateStoreNameURL ? '' : 'branch'} to view data from`}  <strong>{getDateString(selectedDayRange.from, "ll")}</strong>.</p>
                                        :
                                        <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>You have selected <strong>{props.updateStoreNameURL ? props.updateStoreNameURL : option.length}</strong> {option.length > 1 ? `${title ? '' : 'branches'} to view data from` : `${props.updateStoreNameURL ? '' : 'branch'} to view data from`} <strong>{getDateString(selectedDayRange.from, "ll")}</strong> to <strong>{getDateString(selectedDayRange.to, "ll")}</strong>.</p>
                                }
                            </>
                        }
                        {
                            // (props.pageTitle === 'Traffic' || props.pageTitle === 'Heatmaps' || props.pageTitle === "Categories") &&
                            (props.type === "gold") &&

                            <>{console.log('floorId?.name', floorId)}
                                {
                                    getDifference(selectedDayRange.from, selectedDayRange.to) == 0 ?
                                        <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>You have selected  <strong>{floorId?.name}</strong>  of <strong>{storeName}</strong>  to view data for <strong>{getDateString(selectedDayRange.from, "ll")} </strong>.</p>
                                        :
                                        <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>You have selected <strong>{floorId?.name}</strong> of <strong>{storeName}</strong> to view data from <strong>{getDateString(selectedDayRange.from, "ll")}</strong> to <strong>{getDateString(selectedDayRange.to, "ll")}</strong>.</p>

                                }
                            </>
                        }

                        {
                            // props.pageTitle === 'Comparisons' && props.compareType === 'single' &&
                            props.pageTitle === 'Comparisons' && props.compareType === 'single' &&

                            <>
                                <>
                                    <Row>
                                        <Col md={4}>
                                            <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>You have selected  <strong>{storeName}</strong> to view data for</p>

                                        </Col>
                                        {
                                            getDifference(selectedDayRange.from, selectedDayRange.to) == 0 ?
                                                <Col md={2}>
                                                    <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>
                                                        <strong>{getDateString(selectedDayRange?.from, "ll")}</strong> and
                                                    </p>
                                                </Col> :
                                                <Col md={4}>
                                                    <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>
                                                        <strong>{getDateString(selectedDayRange?.from, "ll")}</strong> to <strong>{getDateString(selectedDayRange?.to, "ll")}</strong> and
                                                    </p>
                                                </Col>
                                        }
                                        {
                                            getDifference(selectedDayRangeTwo.from, selectedDayRangeTwo.to) == 0 ?
                                                <Col md={2}>
                                                    <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>
                                                        <strong>{getDateString(selectedDayRangeTwo?.from, "ll")}</strong>
                                                    </p> </Col> :
                                                <Col md={4}>
                                                    <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>
                                                        <strong>{getDateString(selectedDayRangeTwo?.from, "ll")}</strong> to <strong>{getDateString(selectedDayRangeTwo?.to, "ll")}</strong>
                                                    </p>
                                                </Col>
                                        }
                                    </Row>
                                </>
                            </>
                        }
                        {
                            // props.pageTitle === 'Comparisons' && props.compareType === 'multiple' &&
                            props.type === 'compareMultiple' &&

                            <>
                                {
                                    <>
                                        {
                                            getDifference(selectedDayRange.from, selectedDayRange.to) == 0 ?

                                                <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>Compare <strong>{storeName}</strong> and <strong>{storeName2}</strong>   for <strong>{getDateString(selectedDayRange.from, "ll")}</strong>.</p>
                                                :
                                                <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>Compare <strong>{storeName}</strong> and <strong>{storeName2}</strong>  from <strong>{getDateString(selectedDayRange?.from, "ll")}</strong> to <strong>{getDateString(selectedDayRange?.to, "ll")}</strong></p>
                                        }
                                        {/* <p style={{ padding: 0, margin: 0, lineHeight: "2rem" }}>Compare <strong>{storeName}</strong> & <strong>{storeName2}</strong></p> */}
                                    </>
                                }
                            </>
                        }
                    </Col>
                    <Col md={2} className='p-2'>

                        <Dropdown id="filter" style={{ width: "fit-content", float: "right" }} isOpen={showFilters} toggle={toggle} direction='down'>
                            <DropdownToggle nav className='text-dark'>
                                <Filter size="16" /> Filters
                            </DropdownToggle>
                            <DropdownMenu id="main" style={{ width: "max-content", minWidth: "500px", padding: "0px", maxWidth: "1100px", width: "1100px", maxHeight: "515px", marginTop: "5px" }}>
                                <div style={{ paddingLeft: "0.75rem", paddingRight: "0.75rem" }}>
                                    <Row>
                                        {
                                            !customSelection &&
                                            <Fragment>

                                                {/* <Col md={(props.compareType === 'single' || props.pageTitle === "Insights") ? 3 : props.compareType === "multiple" ? 6 : 4} className="pt-3 border-bottom border-1 " > */}
                                                <Col md={(props.compareType === 'single' || props.type === "premium") ? 3 : props.type === "compareMultiple" ? 6 : 4} className="pt-3 border-bottom border-1 " >

                                                    {/* {props.compareType != "multiple" && <h4 className='filter-heading'>Stores</h4>} */}
                                                    {props.type != "compareMultiple" && <h4 className='filter-heading'>Stores</h4>}


                                                    {/* {props.compareType === "multiple" && */}
                                                    {props.type === "compareMultiple" &&

                                                        <h4 className='filter-heading'>Compare  stores</h4>}

                                                    <Row>
                                                        <Col>
                                                        </Col>
                                                    </Row>
                                                    <Row >
                                                        <Col md={props.type === "compareMultiple" ? 6 : 12} className='scrollbar ' id="style-3" >
                                                            <ListGroup  >
                                                                {
                                                                    props.type === "default" &&
                                                                    <>
                                                                        <ListGroupItem className={selection == 'custom' ? 'active' : ''} tag="a" href="#" onClick={() => setCustomSelection(true)}>
                                                                            Custom Selection
                                                                        </ListGroupItem>

                                                                        <ListGroupItem className={selection == 'all' ? 'active' : ''} tag="a" href="#" onClick={(e) => { e.detail == 2 ? setCustomSelection(true) : selectAll() }}>
                                                                            All Stores
                                                                        </ListGroupItem>
                                                                    </>
                                                                }

                                                                {
                                                                    // (props.pageTitle === 'Traffic' || props.pageTitle === "Categories" || props.pageTitle === "Heatmaps" || props.pageTitle === "Comparisons" || props.pageTitle === "Insights") &&
                                                                    props.type != "default" &&

                                                                    storesWithFloors
                                                                }

                                                                {
                                                                    props.type === "default" &&
                                                                    <>
                                                                        {citiesMenu}
                                                                        {branchesMenuCustom}
                                                                    </>
                                                                }
                                                            </ListGroup>

                                                        </Col>
                                                        {/* { props.compareType === "multiple" &&
                                                            <ListGroupItem>Compare With</ListGroupItem>
                                                        } */}
                                                        {props.type === 'compareMultiple' &&
                                                            <Col md={6} className=" border-bottom border-1">
                                                                <ListGroup flush style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                                    {/* {props.pageTitle === "Comparisons" && props.compareType === 'multiple' && */}
                                                                    {props.type === "compareMultiple" &&
                                                                        storesForMUltiple
                                                                    }

                                                                </ListGroup>

                                                            </Col>
                                                        }
                                                    </Row>

                                                </Col>

                                                <Col className="pt-3 border-start border-end border-bottom border-1" md={(props.compareType === 'single') ? 3 : props.pageTitle === "Insights" ? 5 : props.compareType === "multiple" ? 2 : 4}>
                                                    <Row>

                                                        {/* <Col md={props.pageTitle === "Insights" ? 6 : 12} */}
                                                        <Col md={props.type === "premium" ? 6 : 12}

                                                            className=" border-start border-end  border-1  ">
                                                            <h4 className='filter-heading'>Date Filters</h4>
                                                            <div className='scrollbar ' id="style-3" style={{ width: "100%" }}>

                                                                <ListGroup
                                                                    flush
                                                                // style={{ maxHeight: "300px", overflowY: "auto" }}
                                                                >
                                                                    {/* {(props.compareType != 'single' && props.pageTitle != "Insights") && */}
                                                                    {(props.compareType != 'single' && props.type != "premium") &&

                                                                        datesMenu
                                                                    }
                                                                    {/* {(props.compareType != 'single' && props.pageTitle != "Insights") && */}
                                                                    {(props.compareType != 'single' && props.type != "premium") &&
                                                                        datesMenuCustom
                                                                    }

                                                                    {props.compareType === 'single' &&
                                                                        multipleDatesMenuCustom
                                                                    }
                                                                    {
                                                                        props.type === "premium" &&
                                                                        inisghtsDateMenuCustom
                                                                    }
                                                                </ListGroup>
                                                            </div>
                                                        </Col>
                                                        {/* {props.pageTitle === "Insights" && !deleteFilters && */}
                                                        {props.type === "premium" && !deleteFilters &&

                                                            <>

                                                                <Col md={6} className=" border-start border-end  border-1" style={{ backgroundColor: '' }}>
                                                                    <h4 className='filter-heading'>Select Typle</h4>
                                                                    <div className='scrollbar' id="style-3" style={{ width: "100%" }}>
                                                                        <ListGroup >
                                                                            {dateTypeForInsights}
                                                                        </ListGroup>
                                                                    </div>
                                                                </Col>
                                                            </>}
                                                    </Row>

                                                </Col>
                                            </Fragment>
                                        }

                                        {
                                            customSelection &&
                                            // <Col md={(props.compareType === "single" || props.pageTitle === "Insights") ? 6 : deleteFilters ? 8 : customSelection ? 8 : 4} className="pt-3 border-bottom border-end border-1" style={{ maxHeight: '408px' }}>
                                            <Col md={(props.compareType === "single" || props.type === "premium") ? 6 : deleteFilters ? 8 : customSelection ? 8 : 4} className="pt-3 border-bottom border-end border-1" style={{ maxHeight: '408px' }}>

                                                {
                                                    // !deleteFilters && props.pageTitle === "Summary" &&
                                                    !deleteFilters && props.type === "default" &&

                                                    <div>
                                                        <h4 className='filter-heading'> <ArrowLeft style={{ color: colors.primary, cursor: "pointer", marginLeft: "-5px" }} onClick={() => setCustomSelection(false)} /> Customize Selection</h4>
                                                        <Row className='mb-3' >

                                                            {
                                                                branchFilter &&
                                                                <Col>
                                                                    <InputGroup>
                                                                        <Input ref={branchRef} size="sm" type='text' onChange={(e) => setBranchLabel(e.target.value)} placeholder='Filter name. For example, Top Branches' />
                                                                        <Button size="sm" color="outline-danger" onClick={() => setBranchFilter(false)} disabled={branchLoader}><XCircle size={16} /></Button>
                                                                        <Button size="sm" color="outline-primary" onClick={() => createBranchFilter()} disabled={branchLoader}><Bookmark size={16} /> Save Filter</Button>
                                                                    </InputGroup>
                                                                </Col>
                                                            }
                                                            {
                                                                !branchFilter &&
                                                                <Col className='text-end'>
                                                                    {/* { branchFilters.length > 0 && <Button size="sm" color="outline-danger mx-2" onClick={()=>setDeleteFilters(true)}><Trash2 size={16}/> Delete Filters</Button> } */}
                                                                    <Button size="sm" color="outline-primary" onClick={() => setBranchFilter(true)}><Plus size={16} /> Creat Branch Filter</Button>
                                                                </Col>
                                                            }
                                                        </Row>
                                                        <div className='mb-3'>
                                                            <Select options={options} value={option} onChange={setOptionByDefault} isMulti styles={colourStyles} />
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    deleteFilters &&
                                                    <div >

                                                        <h4 className='filter-heading'> <ArrowLeft style={{ color: colors.primary, cursor: "pointer", marginLeft: "-5px" }} onClick={() => { setDeleteFilters(false); props.type != "default" && setCustomSelection(false) }} /> Delete Filters</h4>
                                                        <Row className='mb-3 ' id='wrapper' >
                                                            <Col className="scrollbar" id="style-3">
                                                                <ListGroup className="force-overflow">


                                                                    {
                                                                        branchFilters.length == 0 && dateFilters.length == 0 &&
                                                                        <ListGroupItem
                                                                            disabled
                                                                            href="#"
                                                                            tag="a"

                                                                        >
                                                                            No Custom Filters Available
                                                                        </ListGroupItem>
                                                                    }
                                                                    {
                                                                        branchFilters.length > 0 &&
                                                                        <ListGroupItem
                                                                            disabled
                                                                            href="#"
                                                                            tag="a"

                                                                        >
                                                                            Branch Filters ( {branchFilters.length} )
                                                                        </ListGroupItem>
                                                                    }
                                                                    {
                                                                        branchFilters.map((row, index) => {
                                                                            return (
                                                                                <ListGroupItem key={"delete-branch-filter-" + index}>
                                                                                    {row.label} <Button size='sm' color='outline-danger' style={{ float: "right", padding: "2px 5px" }} onClick={() => { localDeleteFilter(row._id) }}><Trash2 size={14} /></Button>
                                                                                </ListGroupItem>
                                                                            );
                                                                        })
                                                                    }

                                                                    {
                                                                        dateFilters.length > 0 &&
                                                                        <ListGroupItem
                                                                            disabled
                                                                            href="#"
                                                                            tag="a"

                                                                        >
                                                                            Date Filters ( {dateFilters.length} )
                                                                        </ListGroupItem>
                                                                    }
                                                                    {
                                                                        dateFilters.map((row, index) => {
                                                                            return (
                                                                                <ListGroupItem key={"delete-date-filter-" + index}>
                                                                                    {row.label} <Button size='sm' color='outline-danger' style={{ float: "right", padding: "2px 5px" }} onClick={() => { localDeleteFilter(row._id) }}><Trash2 size={14} /></Button>
                                                                                </ListGroupItem>
                                                                            );
                                                                        })
                                                                    }
                                                                </ListGroup>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                }
                                            </Col>
                                        }

                                        <Col md={props.compareType === "single" ? 6 : deleteFilters ? 4 : customSelection ? 4 : 4} className='border-bottom border-1'>
                                            <Row>
                                                <Col md={props.compareType === "single" ? 6 : 12}>
                                                    {/* {props.pageTitle === "Insights" && (selectType === 'insightsweekly' || selectType === "insightsdaily") && */}
                                                    {props.type === "premium" && (selectType === 'insightsweekly' || selectType === "insightsdaily") &&

                                                        <Calendar
                                                            className='pt-0'
                                                            value={selectedDayRange}
                                                            onChange={setDateAndRangeForInsights}
                                                            colorPrimary={colors.primary}
                                                            colorPrimaryLight={colors.highlight}
                                                            maximumDate={getDateObject(moment(new Date()))}
                                                        />}
                                                    {props.type != "premium" &&
                                                        <Calendar
                                                            className='pt-0'
                                                            value={selectedDayRange}
                                                            onChange={props.type === "silver" ? setDateForEmployeeActivity : setSelectedDayRangeFromCalendar}
                                                            colorPrimary={colors.primary}
                                                            colorPrimaryLight={colors.highlight}
                                                            maximumDate={getDateObject(moment(new Date()))}
                                                        />
                                                    }
                                                    {selectType === "insightsyearly" &&
                                                        <>
                                                            <div className='filter-heading mx-2 ' style={{ textAlign: "", marginTop: '25px', fontFamily: "inherit", }}>
                                                                <ArrowLeft className='' style={{ color: 'black', cursor: "pointer", marginLeft: "10px" }} onClick={() => setYearRange(yearRnage + 12)} />
                                                                <span className='mx-5'>{years[years?.length - 1]?.value}-{years[0]?.value}</span>
                                                                <ArrowRight style={{ color: 'black', cursor: "pointer", marginLeft: "", }} onClick={() => setYearRange(yearRnage - 12)} />
                                                            </div>

                                                            <div className='insightYearParentDiv ' >

                                                                {years?.map((year) => (
                                                                    <div className={insightsYearlyDate?.value === year.value ? " insightYearActive insightYear m-4 px-4" : "  insightYear m-4 px-4"} onClick={() => setInsightsYearlyDate(year)}>{year.label}</div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    }
                                                </Col>
                                                {(props.compareType === "single") &&
                                                    <Col md={props.compareType === "single" ? 6 : 12}>
                                                        <Calendar
                                                            className='pt-0'
                                                            value={selectedDayRangeTwo}
                                                            onChange={setSelectedDayRangeFromCalendarTwo}
                                                            colorPrimary={colors.primary}
                                                            colorPrimaryLight={colors.highlight}
                                                            maximumDate={getDateObject(moment(new Date()))}
                                                        />
                                                    </Col>}
                                            </Row>
                                            <Row className='mb-2' >
                                                {
                                                    dateFilter &&
                                                    <Col>
                                                        <InputGroup>
                                                            <Input ref={dateRef} size="sm" type='text' onChange={(e) => setDateLabel(e.target.value)} placeholder='Ex. Ramadan 2022' />
                                                            <Button size="sm" color="outline-danger" onClick={() => setDateFilter(false)} disabled={dateLoader}><XCircle size={16} /></Button>
                                                            {/* {(props.compareType != 'single' && props.pageTitle != "Insights") && <Button size="sm" color="outline-primary" onClick={() => createDateFilter()} disabled={dateLoader}><Bookmark size={16} /> Save </Button> */}
                                                            {(props.compareType != 'single' && props.type != "premium") && <Button size="sm" color="outline-primary" onClick={() => createDateFilter()} disabled={dateLoader}><Bookmark size={16} /> Save </Button>

                                                            }
                                                            {props.compareType === 'single' && <Button size="sm" color="outline-primary" onClick={() => createMultipleDateFilter()} disabled={dateLoader}><Bookmark size={16} /> Save multipleDate </Button>
                                                            }
                                                            {/* {props.pageTitle === "Insights" && */}
                                                            {props.type === "premium" &&
                                                                <Button size="sm" color="outline-primary" onClick={() => createInsightsDateFilter()} disabled={dateLoader}><Bookmark size={16} /> Save ! </Button>
                                                            }
                                                        </InputGroup>
                                                    </Col>
                                                }
                                                {
                                                    !dateFilter &&
                                                    <Col className='text-end'>
                                                        {(dateFilters.length > 0 || dateFilters.length > 0) && <Button size="sm" color="light mx-2" style={{ color: colors.primary }} onClick={() => { setDeleteFilters(true); setCustomSelection(true) }}>View Filters</Button>}
                                                        <Button size="sm" color="outline-primary" onClick={() => setDateFilter(true)}><Plus size={16} /> Creat Date Filter</Button>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={10}>
                                        </Col>
                                        {/* <Col md={2} className='text-end p-3'>
                                            {props.pageTitle === 'Comparisons' &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForComparison()}>Compare</Button>
                                            }
                                            {props.pageTitle === 'Summary' && props.pageTitle != "Insights" &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilter()}>Search</Button>
                                            }
                                            {(props.pageTitle === "Insights" || props.pageTitle === "Conversion" || props.pageTitle === "Employee_Activity") &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForInsightsAndConversion()}>Search</Button>
                                            }
                                            {(props.pageTitle === "Traffic" || props.pageTitle === "Heatmaps" || props.pageTitle === "Categories") &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForGold()}>Search</Button>
                                            }
                                        </Col> */}
                                        <Col md={2} className='text-end p-3'>
                                            {props.type === 'compareMultiple' &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForComparison()}>Compare</Button>
                                            }
                                            {props.type === 'default' &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilter([])}>Search</Button>
                                            }
                                            {(props.type === "premium" || props.pageTitle === "Conversion" || props.type === "silver") &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForInsightsAndConversion()}>Search</Button>
                                            }
                                            {(props.type === "gold") &&
                                                <Button color="primary" className='w-100' onClick={() => updateFilterForGold()}>Search</Button>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default MainFilter;